import * as React from "react";
import { OnChangeValue, StylesConfig, components } from "react-select";

import Select from "shared/components/select/Select";
import { IEnvironmentData } from "monitoringRules/shared/model";
import { Option, FixedOption } from "shared/model/Option";
import { Utilities } from "shared/utilities";

const { Option: ReactSelectMenuOption } = components;

const EnvironmentSelectMenuLinkOption: React.FC<any> = (props) => {
    return (
        <ReactSelectMenuOption {...props}>
            <a
                tabIndex={-1}
                href={props.data.linkHref}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => e.preventDefault()}
                style={{
                    display: 'flex',
                    color: 'inherit',
                    padding: '8px 12px',
                }}
            >
                {props.data.label}
            </a>
        </ReactSelectMenuOption>
    );
}

const MonitoringRulesEnvironmentSelectMenu: React.FC<IMonitoringRulesEnvironmentSelectMenuProps> = (props) => {
    const environmentSelectMenuOptions: FixedOption[] = props.environments.map((env) => {
        return {
            label: env.displayName,
            value: env.name,
            isSelected: env.name === props.currentEnvironmentName,
            linkHref: props.getOptionLinkHref(env.name),
        }
    });

    const handleEnvironmentChange = (selected: OnChangeValue<Option, false>) => {
        props.onEnvironmentChange(selected?.value);
    };

    const selectStyles: StylesConfig<FixedOption> = {
        container: (provided) => ({
            ...provided,
            flex: '1'
        })
    };

    return (
        <Select
            classNamePrefix="react-select"
            className="monitoring-rules-environment-select"
            options={environmentSelectMenuOptions}
            value={Utilities.valueFromId(environmentSelectMenuOptions, props.currentEnvironmentName)}
            styles={selectStyles}
            onChange={handleEnvironmentChange}
            menuPortalTarget={document.body}
            components={{ Option: EnvironmentSelectMenuLinkOption }}
            isAgentGroupSelectorWithLinks
        />
    )
}

export interface IMonitoringRulesEnvironmentSelectMenuProps {
    currentEnvironmentName: string;
    environments: IEnvironmentData[];
    onEnvironmentChange: (environmentName: string) => void;
    getOptionLinkHref: (environmentName: string) => string;
}

export default MonitoringRulesEnvironmentSelectMenu;